<template>
  <div class="container">
    <top-nav :title="'文章详情'"></top-nav>

    <div class="main-container" v-if="news">
      <h1 class="article__title">{{ news.title }}</h1>
      <div class="article__content" id="content" v-html="news.content"></div>
    </div>

    <Footer />
  </div>
</template>

<script>
import TopNav from "@/components/TopNav";
import Footer from "@/components/Footer";
import { getNewDetail } from "@/api/news";


export default {
  name: "Index",
  components: {
    TopNav,
    Footer,
  },
  data() {
    return {
      id: 0,
      news: null,
    };
  },
  computed: {},
  beforeCreadted() {},
  created() {
    this.id = this.$route.params.id;
    this.getData()
  },
  beforeDestroy() {},
  methods: {
    getData() {
      getNewDetail(this.id).then(resp => {
        this.news = resp.data
      })
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 800px;
  // overflow: hidden;
  margin: 0 auto;
}
.main-container {
  padding: 0.8rem 0;
  background-color: #fff;
  height: 100%;
  .article__title {
    margin: 11px 20px 0;
    font-size: 24px;
    font-weight: 700;
    color: #111e36;
    line-height: 32px;
  }
  .article__content {
    margin: 12px 20px;
    font-size: 18px;
    color: #111e36;
    line-height: 34px;
    text-align: justify;
  }
}
</style>

